// extracted by mini-css-extract-plugin
export var colorStripes = "m_3";
export var disclaimerStyle = "m_5";
export var genericBackgroundColor = "m_4";
export var skeletonRow = "m_0";
export var stickyClass = "m_2";
export var table = "m_h";
export var tableWrapper = "m_1";